<button type="button" class="btn btn-{{class}}" placement="bottom-right" container="body" [disabled]="disabled"
  [ngbTooltip]="'ui.table.reset-filters'|translate" (click)="resetFilter()">
  <i class="fa fa-undo"></i>
</button>
